import React, { useContext, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Typography, CircularProgress } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es';
import { I18nContext } from 'translations';
import { useForm, Controller } from 'react-hook-form';
import { editScheduledDatetime } from 'context/express/actions';
import { useStateValue } from 'context/store';
import { modalMessage, toIsoString } from 'utils';
import { INITIAL_PAGE } from 'utils/constants';
import { messageReservation as closeMessage } from 'context/commons/actions';

export default function ModalEditScheduledDatetime({ handleModal, open, bookingId, scheduledAt, getBookings }) {
  const { translate } = useContext(I18nContext);
  const [loading, setLoading] = useState(false);
  const [, dispatch] = useStateValue();

  const { handleSubmit, control } = useForm();

  const messageOk = (mssg) => {
    modalMessage('', mssg, 'success', translate('accept'), true).then(() => {
      setLoading(false);
      handleModal();
      getBookings(INITIAL_PAGE);
      closeMessage(dispatch, null);
    });
  };

  const submit = async (values) => {
    if (!values.scheduled_at) return;
    setLoading(true);
    const isoDate = toIsoString(new Date(values.scheduled_at));
    const callback = await editScheduledDatetime(bookingId, isoDate, dispatch);
    callback.status ? messageOk(callback?.mssgOk) : setLoading(false);
  };

  return (
    <Dialog open={open} onClose={handleModal} maxWidth="xs" fullWidth>
      <Typography className="text-center" variant="h5" color="primary" style={{ padding: 20 }}>
        {translate('scheduledDatetime.title')}
      </Typography>
      <DialogContent>
        <form onSubmit={handleSubmit(submit)} noValidate>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
            <Controller
              name="scheduled_at"
              control={control}
              defaultValue={scheduledAt ? new Date(scheduledAt) : null}
              render={({ onChange, value }) => (
                <KeyboardDateTimePicker
                  size="small"
                  inputVariant="outlined"
                  label={translate('scheduledDatetime.title')}
                  format="dd/MM/yyyy hh:mm a"
                  cancelLabel={translate('cancel')}
                  okLabel={translate('accept')}
                  minDate={new Date()}
                  invalidDateMessage={translate('invalidFormat')}
                  value={value}
                  onChange={onChange}
                  fullWidth
                />
              )}
            />
          </MuiPickersUtilsProvider>
          <div className="text-center" style={{ marginTop: 20 }}>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              startIcon={loading ? <CircularProgress size={18} /> : null}
              disabled={loading}
            >
              {translate('save')}
            </Button>
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleModal}>
          {translate('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
